var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfileFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M4.825 19.443l-.496.433-.658-.752 3.717-3.253a1.5 1.5 0 01.988-.371h7.248a1.5 1.5 0 01.988.371l3.717 3.253-.658.752-.484-.423.436.479A10.963 10.963 0 0112 23a10.963 10.963 0 01-7.62-3.068l.444-.49z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.5,
    r: 3.5,
    fill: props.color
  }));
}
export default SvgIconProfileFill;